import type { StyleProperties } from '@wix/thunderbolt-becky-types'
import { color } from '@wix/thunderbolt-commons'
import type { NativeColorAPI } from '../types/carmiAPI/colorApi'
import type { DefaultBrightnessCSSVars } from '../types/css'

const { brighten, extractThemeColor, getFromColorMap, getRGBAColorString, isValidColor, splitColor } = color

export const colorApi: NativeColorAPI = {
	...color,
	getBrightnessCSSVars<BrightnessCSSVars extends Partial<Record<string, string>> = DefaultBrightnessCSSVars>({
		styleProperties,
		siteColors,
		paramName = 'shc',
		fallbackName = 'bg',
		alpha = 0.5,
		mutatedParamName,
	}: {
		styleProperties: StyleProperties
		siteColors: Array<string>
		paramName?: string | undefined
		fallbackName?: string | undefined
		alpha?: number | undefined
		mutatedParamName?: string | undefined
	}): BrightnessCSSVars {
		const param = styleProperties[paramName] || styleProperties[fallbackName]
		if (!param) {
			return {} as BrightnessCSSVars
		}
		const paramValue = getFromColorMap(param, siteColors) || param

		return {
			[`--${mutatedParamName ? mutatedParamName : paramName}-mutated-brightness`]: splitColor(
				brighten(getFromColorMap(paramValue), alpha)!
			),
		} as BrightnessCSSVars
	},
	parseColorToRGBA(clr: string, colorOpacity: number): string {
		const parsedColor = extractThemeColor(clr || 'none')
		const isValid = isValidColor(parsedColor)
		const opacity = typeof colorOpacity === 'number' ? colorOpacity : 1
		const isTransparent = !isValid || clr === 'none' || clr === 'noColor' || opacity === 0
		if (isTransparent) {
			return 'transparent'
		}

		if (parsedColor.startsWith('color_')) {
			return `rgb(var(--${parsedColor})${opacity === 1 ? '' : `, ${opacity}`}})`
		}

		if (parsedColor === 'color_undefined') {
			return '#FFFFFF'
		}

		return getRGBAColorString(clr, opacity)
	},
}
